jQuery(document).ready(function ($) {
    // on adding an item to the cart on a single page
    $('form.cart').on('submit', function (e) {

        e.preventDefault();

        let cartwrapper = $('.cart-wrapper'),
            spinner = $('.spinner');

        let thisbutton = $(this).find('button[type="submit"]'),
            form = $(this),
            form_data = {
                product_id: thisbutton.val()
            };

        $.each(form.serializeArray(), function() {
            form_data[this.name] = this.value;
        });

        // remove this key to avoid double-adding
        delete form_data['add-to-cart'];
            
        let data = {
            action: 'lr_woocommerce_ajax_add_to_cart',
            ...form_data
        };

        $(document.body).trigger('adding_to_cart', [thisbutton, data]);

        $.ajax({
            type: 'post',
            url: wc_add_to_cart_params.ajax_url,
            data: data,

            beforeSend: function (response) {
                cartwrapper.addClass('custom-add-to-cart');
                spinner.removeClass('hidden');
            },

            complete: function (response) {
                cartwrapper.removeClass('custom-add-to-cart');
                spinner.addClass('hidden');
            },

            success: function (response) {
                if (response.error && response.product_url) {
                    window.location = response.product_url;
                    return;
                }
                if (wc_add_to_cart_params.cart_redirect_after_add === 'yes') {
                    window.location = wc_add_to_cart_params.cart_url;
                    return;
                }

                // Remove existing notices
                $('.woocommerce-error, .woocommerce-message, .woocommerce-info').remove();

                // Add new notices
                $('.woocommerce-notices-wrapper').html(response.fragments.notices_html);

                // scroll to the top
                $('html, body').animate({ scrollTop: 0 }, 0);

                if (!response.fragments.has_error_notice) {
                    $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, thisbutton]);
                    // open the mini cart
                    $('#mini-cart').addClass('cart-open');
                    // close mini cart after 4 seconds
                    setTimeout(function () {
                        $('#mini-cart').removeClass('cart-open');
                    }, 4000);
                }
            },
        });
    });
});